import primaryComponents from "../../../primaryComponents";
import styles from "./styles.module.scss";
import { LoyaltyPoint } from "./LoyaltyPoint";
import { GiftCode } from "./GiftCode";
import { useState } from "react";
import { ToolBtn } from "../ToolBtn";
import secondaryComponents from "../..";
import { useGetCampaigns } from "../../../../hooks/api/queries/useLoyalty";
import { pathConstants } from "../../../../routes/pathContants";
import Icon from "../../../../assets/icons";

const Loyalty = ({ currency_symbol, btnStyle = {} }) => {
  const [loyaltyType, setLoyaltyType] = useState("GIFT_CARD");
  const [isActive, setIsActive] = useState(false);
  const { data: campaigns, isLoading } = useGetCampaigns({
    queries: "",
    isEnabled: isActive,
  });

  return (
    <>
      <ToolBtn
        text="Loyalty"
        color="#47BE79"
        bgColor="#E8F7EE"
        style={btnStyle}
        onClick={() => setIsActive(true)}
      />
      <secondaryComponents.Modal
        width={700}
        isActive={isActive}
        closeModal={() => setIsActive(false)}
      >
        <secondaryComponents.LoaderHelper
          classNames={"mt-5"}
          isLoading={isLoading}
        >
          {campaigns?.data?.length > 0 ? (
            <div className={styles.container}>
              <h4 className="text-center">Apply Loyalty</h4>

              <div className={"d-flex"} style={{ gap: "20px" }}>
                <primaryComponents.BoxedRadioInput
                  value={loyaltyType}
                  name={"loyaltyType"}
                  id="GIFT_CARD"
                  isChecked={loyaltyType === "GIFT_CARD"}
                  classNames={styles.checkbox}
                  setRadioValue={() => {
                    setLoyaltyType("GIFT_CARD");
                  }}
                >
                  Gift Card
                </primaryComponents.BoxedRadioInput>
                <primaryComponents.BoxedRadioInput
                  value={loyaltyType}
                  name={"loyaltyType"}
                  id="LOYALTY_POINT"
                  isChecked={loyaltyType === "LOYALTY_POINT" ? true : false}
                  classNames={styles.checkbox}
                  setRadioValue={() => {
                    setLoyaltyType("LOYALTY_POINT");
                  }}
                >
                  Loyalty
                </primaryComponents.BoxedRadioInput>
              </div>

              {loyaltyType === "GIFT_CARD" ? (
                <GiftCode
                  currency_symbol={currency_symbol}
                  loyaltyType={loyaltyType}
                  closeModal={() => setIsActive(false)}
                />
              ) : (
                <LoyaltyPoint
                  currency_symbol={currency_symbol}
                  loyaltyType={loyaltyType}
                  closeModal={() => setIsActive(false)}
                />
              )}
            </div>
          ) : (
            <div className="text-center p-4">
              <h4>Apply Loyalty</h4>

              <img
                className="my-3"
                width={200}
                src={Icon.campaign}
                alt="campaign"
              />

              <h5>You have no existing campaign</h5>

              <primaryComponents.Button
                classNames={"btn btn--primary mx-auto"}
                onClick={() => {
                  window.open(pathConstants.LOYALTY_CREATE_CAMPAIGN, "_blank");
                }}
              >
                Create Your First Campaign!
              </primaryComponents.Button>
            </div>
          )}
        </secondaryComponents.LoaderHelper>
      </secondaryComponents.Modal>
    </>
  );
};
export default Loyalty;
